import React from 'react';
import { string, number, oneOfType } from 'prop-types';
import { dateTimeFormat, DATETIME_ELEMENT_STYLES } from '@fiverr-private/localization';

const DateDisplay = ({ date }) => {
    if (!date) {
        return null;
    }

    return (
        <span>
            { dateTimeFormat(new Date(date), {
                year: DATETIME_ELEMENT_STYLES.NUMERIC,
                month: DATETIME_ELEMENT_STYLES.SHORT
            })}
        </span>
    );
};

DateDisplay.propTypes = {
    date: oneOfType([string, number]) // Ex. "2017-04-01" | 1583020800000
};

export default DateDisplay;
